export * from './BagRailInfoPanelText';
